import { useForm } from 'react-hook-form'
import Page from 'src/features/transfers/components/TransferReceive/Page/Page'
import UserIdentifier from 'src/features/transfers/components/TransferReceive/UserIdentifier/UserIdentifier'
import * as S from './ReceiveStart.styles'
import ScanCodeIcon from 'src/assets/images/other-images/ScanCode.svg'
import { InputAdornment } from '@mui/material'
import { actions } from '../../../TransfersState'
import { useDispatch } from 'react-redux'
import { useSelector } from 'src/utils/store'
import { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useFulfillmentCenter } from 'src/hooks/useFulfillmentCenter'

interface FormData {
  cageAddress: string
  invoiceAccessKey: string
}

const ReceiveStart = () => {
  const {
    register,
    getValues,
    setFocus,
  } = useForm<FormData>()

  const { receiveUser } = useSelector((state) => state.transfers)
  const dispatch = useDispatch()
  const history = useHistory()

  const { fc } = useFulfillmentCenter()

  const [preventDoubleRequest, setPreventDoubleRequest] = useState(false)

  const onSubmit = () => {
    if (preventDoubleRequest) {
      return
    }

    const cageAddress = getValues('cageAddress')
    const invoiceAccessKey = getValues('invoiceAccessKey')

    if (cageAddress && !invoiceAccessKey) {
      setFocus('invoiceAccessKey')
    } else if (!cageAddress && invoiceAccessKey) {
      setFocus('cageAddress')
    } else if (cageAddress && invoiceAccessKey) {
      setPreventDoubleRequest(true)
      dispatch(actions.receiveStart({
        badge: receiveUser?.badge || '',
        idFulfillmentCenter: fc.id,
        cageAddress,
        invoiceAccessKey,
        history,
        onFinish: () => setPreventDoubleRequest(false),
      }))
    }
  }

  const handleOnKeyDown = (event: React.KeyboardEvent) => {
    const enterKeyCode = 13
    const tabKeyCode = 9

    if ([enterKeyCode, tabKeyCode].includes(event.keyCode) && !event.shiftKey) {
      event.preventDefault()
      onSubmit()
    }
  }

  return (
    <Page headerTitle='Receber Transferência'>
      <UserIdentifier />
      <S.Form>
        <S.CustomTextField
          onKeyDown={(e) => handleOnKeyDown(e)}
          name='cageAddress'
          id='cageAddress'
          label='Endereço da gaiola'
          type='text'
          autoFocus
          InputProps={{
            endAdornment: (
              <InputAdornment
                position='end'
                sx={{ cursor: 'pointer' }}
                data-testid='input-adornment-test-id'
              >
                <img src={ScanCodeIcon} alt='scan code icon' data-testid='scan-code-icon-test-id' />
              </InputAdornment>
            ),
            inputProps: {
              ...register('cageAddress'),
              'data-testid': 'cage-address-test-id',
            },
          }}
          disabled={preventDoubleRequest}
        />
        <S.CustomTextField
          onKeyDown={(e) => handleOnKeyDown(e)}
          name='invoiceAccessKey'
          id='invoiceAccessKey'
          label='Chave de acesso'
          type='text'
          InputProps={{
            endAdornment: (
              <InputAdornment
                position='end'
                sx={{ cursor: 'pointer' }}
                data-testid='input-adornment-test-id'
              >
                <img src={ScanCodeIcon} alt='scan code icon' data-testid='scan-code-icon-test-id' />
              </InputAdornment>
            ),
            inputProps: {
              ...register('invoiceAccessKey'),
              'data-testid': 'invoice-access-key-test-id',
            },
          }}
          disabled={preventDoubleRequest}
        />
      </S.Form>
    </Page>
  )
}

export default ReceiveStart
